module.exports = __webpack_public_path__ + "static/sefastone-detail2-e00f4de435a28cea71ab60fc268a0bf3.png";